<template>
  <div class="weeklist-wrap">
    <empty v-if="loading === false && list.length === 0" :tag="true" />
    <template v-else>
      <div class="custom-table">
        <div class="custom-thead">
          <van-row>
            <van-col span="12">日期</van-col>
            <van-col span="6">分数</van-col>
            <van-col span="6">答题时长</van-col>
          </van-row>
        </div>
        <div class="custom-tbody stripe">
          <van-list
            v-model="loading"
            :finished="finished"
            finished-text="仅展示近3天内的数据"
            @load="getData"
          >
            <van-row v-for="(item, index) in list" :key="index">
              <van-col span="12">{{ item.create_time }}</van-col>
              <van-col span="6">{{
                item.score === -1 ? "---" : item.score
              }}</van-col>
              <van-col span="6" v-if="item.duration === -1">---</van-col>
              <van-col span="6" v-else>{{ item.duration }}</van-col>
            </van-row>
          </van-list>
          <!-- <div class="custom-status">
            <span class="custom-status__loading" v-if="loading">加载中……</span>
            <span class="custom-status__finished" v-else-if="!loading"
              >没有更多了～</span
            >
          </div> -->
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import Empty from "./Empty";
export default {
  components: {
    Empty,
  },
  data() {
    return {
      // 列表
      list: [],
      loading: false,
      currentPage: 1,
      finished: false,
    };
  },
  methods: {
    // 获取每日答题数据
    async getData() {
      try {
        this.loading = true;
        const res = await this.$axios.post(`/Question/getAnswerLog`, {
          page: this.currentPage,
          size: 10,
        });
        if (res.data && res.data.list.length > 0) {
          res.data.list.forEach((element) => {
            this.list.push(element);
          });
          this.currentPage++;
        }
        this.loading = false;
        if (this.list.length >= Number(res.data.total)) {
          this.finished = true;
        }
      } catch (error) {
        this.$notify({
          type: "danger",
          message: error.errorMsg || `获取数据失败`,
          duration: 2000,
        });
      } finally {
        this.loading = false;
      }
    },
  },
  created() {
    this.getData();
  },
};
</script>
<style lang="scss" scoped>
.weeklist-wrap {
  .custom-table {
    .custom-thead,
    .custom-tbody {
      .van-row {
        padding-left: 20px;
      }
    }
    .custom-tbody {
      height: calc(100vh - 51px - 45px);
      overflow: auto;
    }
  }
}
</style>
